import { render, staticRenderFns } from "./UserDetailsComponent.vue?vue&type=template&id=1cb95ff4"
import script from "./UserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./UserDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./UserDetailsComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports